import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, PageProps, SECURABLE} from "core/metamodel/metaConstant";
import {PAGE} from "routes";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {loc} from "core/common/config/locales";
import {BulkAction, BULKACTIONTYPE} from "core/grid/component/gridComp";
import Grid from "core/grid/domain/grid";
import {SHIPMENTDIRECTION} from "shipment/shipmentDomain";

const gridLocation = 'shipmentOutgoingList';


@observer
export default class ShipmentOutgoingList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.shipment;
  static title = loc.i18n`Outgoing Shipments`;
  static icon = 'fighter-jet';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("ShipmentOutgoingList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }

  newShipmentVisit = (grid: Grid) => {
    let gridParams = grid.createFullParams();
    gridParams.includeRowObject = true;
    this.context.router.transitionTo("shipmentVisitDetail", {id: 'new'}, gridParams);
  };



  render() {
    let {params, query} = this.props;

    let bulkActions: BulkAction[] = [
      {type: BULKACTIONTYPE.ACTION, label: 'Create Shipment visit', fn: this.newShipmentVisit, that:this, securable: SECURABLE.shipmentVisitDetail}
    ];


    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)}  entities={mdEntityService.entityMap} gridId={params.gridId} query={query}
                         bulkActions={bulkActions} multiUpdateSecurable={SECURABLE.shipmentGridUpdate}>
        <ZzFlatButtonRoute onGridToolbar routeName="shipmentDetail" params={{id: 'new'}} query={{shipmentDirection: SHIPMENTDIRECTION.OUTGOING}} label={loc.i18n`New Out Shipment`} permission={PERMISSION.New} securable={PAGE.shipmentDetail}/>


      </GridCompConnected>
    );
  }

}



// WEBPACK FOOTER //
// ./src/shipment/page/shipmentOutgoingList.tsx